// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-dialog .export-btn[data-v-7a4c7a04]{width:120px;font-size:14px;color:#df5813;font-weight:400;cursor:pointer;margin:5px 0 0 auto}.order-dialog .export-btn img[data-v-7a4c7a04]{width:20px;height:20px;vertical-align:middle;margin-right:5px}", ""]);
// Exports
module.exports = exports;
